module.exports = __webpack_public_path__ + "img/п.6.c6b11a8c.png";